import { render } from "./IntestineSpecificSectionDetails.vue?vue&type=template&id=553d17d0&scoped=true"
import script from "./IntestineSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./IntestineSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./IntestineSpecificSectionDetails.vue?vue&type=style&index=0&id=553d17d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553d17d0"],['__file',"src/components/IntestineSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "553d17d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('553d17d0', __exports__)) {
    api.reload('553d17d0', __exports__)
  }
  
  module.hot.accept("./IntestineSpecificSectionDetails.vue?vue&type=template&id=553d17d0&scoped=true", () => {
    api.rerender('553d17d0', render)
  })

}


export default __exports__